var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMatter)?_c('Benefit',{attrs:{"sku":_vm.sku}}):_c('Matter',{attrs:{"sku":_vm.sku}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }